/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Status_PendingInputs */

const vi_sl_note_status_pending = /** @type {(inputs: Sl_Note_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

/**

* @param {Sl_Note_Status_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_status_pending = /** @type {((inputs?: Sl_Note_Status_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Status_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_status_pending(inputs)
});